import React from "react";
import { io } from "socket.io-client";
import { REACT_APP_BASE_PATH } from "src/constants";

export const socket = io(REACT_APP_BASE_PATH, {
  reconnection: true,
  transports: ["websocket"],
});
export const SocketContext = React.createContext(socket);
